import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';

import '../../styles/core.scss';
import css from './index.scss';

import {
    curriculumTypeOptions,
    isEmptyString
} from '../../helpers/utils';
import { COUNTRY_CURRICULUM_ID } from '../../constants';

import DropdownList from '../dropdown-list';
import FileUpload from '../file-upload';
import Button from '../button';
import DisplayTable from './display-table';
import LoaderSpinner from './loader-spinner';

/**
 * CURRICULUM DOCUMENTS
 * ----------------------
 * containers/curriculum-documents passes all state and dispatch props
 * points to containers/curriculum-list reducer to use consistent values and not need to refactor
 * manages filtering, uploading and management of curriculum documents
 */
const CurriculumDocuments = ({
    countries,
    curriculumAlignmentDocuments,
    curriculumType,
    documents,
    fileUploadRef,
    handleCountryOnChange,
    handleCurriculumTypeOnChange,
    handleDocumentOnChange,
    handleFileUpload,
    handlePublicationOnChange,
    handleSectionOnChange,
    handleStateOnChange,
    onDeleteFile,
    onDownloadFile,
    onUploadFile,
    publications,
    sections,
    selectedCountry,
    selectedDocument,
    selectedPublication,
    selectedSection,
    selectedState,
    states,
    uploadedFile,
    isRequesting,
    isUploadingFile
}) => (
    <div className={css.curriculumLDocumentComponent}>
        <div className={css.curriculumFilterComponent}>
            <DropdownList
                name="curriculumType"
                onChange={handleCurriculumTypeOnChange}
                options={curriculumTypeOptions}
                placeholder="Curriculum type"
                value={curriculumType} />

            <DropdownList
                name="countries"
                disabled={curriculumType !== COUNTRY_CURRICULUM_ID}
                onChange={handleCountryOnChange}
                options={countries}
                placeholder="Select a country"
                value={selectedCountry} />

            <DropdownList
                name="states"
                disabled={curriculumType !== COUNTRY_CURRICULUM_ID}
                onChange={handleStateOnChange}
                options={states}
                placeholder="Select a state"
                value={selectedState} />

            <DropdownList
                name="publications"
                onChange={handlePublicationOnChange}
                options={publications}
                placeholder="Select a publication"
                value={selectedPublication} />

            <DropdownList
                name="document"
                onChange={handleDocumentOnChange}
                options={documents}
                placeholder="Select a document"
                value={selectedDocument} />

            <DropdownList
                name="section"
                onChange={handleSectionOnChange}
                options={sections}
                placeholder="Select a section"
                value={selectedSection} />

            <FileUpload
                buttonLabel="Browse..."
                fileName={uploadedFile ? uploadedFile.name : null}
                inputRef={fileUploadRef}
                labelText="Upload file:"
                onChangeHandler={handleFileUpload}
            />

            <Button
                variant="dark"
                label="Upload"
                disabled={
                    !uploadedFile ||
                    isRequesting ||
                    isEmptyString(selectedSection)
                }
                containerClassName={css.uploadButton}
                handleOnClick={onUploadFile}
            />
        </div>

        {Object.keys(curriculumAlignmentDocuments).length !== 0 && (
            <DisplayTable
                curriculumAlignmentDocuments={curriculumAlignmentDocuments}
                isRequesting={isRequesting}
                onDeleteFile={onDeleteFile}
                onDownloadFile={onDownloadFile}
            />
        )}

        {isUploadingFile && <LoaderSpinner />}
    </div>
);

CurriculumDocuments.propTypes = {
    countries: PropTypes.array,
    curriculumAlignmentDocuments: PropTypes.object,
    curriculumType: PropTypes.string,
    documents: PropTypes.array,
    fileUploadRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    handleCountryOnChange: PropTypes.func,
    handleCurriculumTypeOnChange: PropTypes.func,
    handleDocumentOnChange: PropTypes.func,
    handleFileUpload: PropTypes.func,
    handlePublicationOnChange: PropTypes.func,
    handleSectionOnChange: PropTypes.func,
    handleStateOnChange: PropTypes.func,
    onUploadFile: PropTypes.func,
    onDeleteFile: PropTypes.func,
    onDownloadFile: PropTypes.func,
    publications: PropTypes.array,
    sections: PropTypes.array,
    selectedCountry: PropTypes.string,
    selectedDocument: PropTypes.string,
    selectedPublication: PropTypes.string,
    selectedSection: PropTypes.string,
    selectedState: PropTypes.string,
    states: PropTypes.array,
    uploadedFile: PropTypes.object,
    isRequesting: PropTypes.bool,
    isUploadingFile: PropTypes.bool
};

export default styleable(css)(CurriculumDocuments);



// WEBPACK FOOTER //
// ./app/components/curriculum-documents/index.js